module.exports = __webpack_public_path__ + "img/bmr-minion.6559191b.png";